import { createContext } from "react";

export interface ThemeContextType {
    theme: string;
    themes: string[];
    darkTheme: string;
    lightTheme: string;
    toggleIsDisabled: boolean;
    toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextType | null>(null);